import type { EmptyStateBlock } from "../types"

// "No data yet" placeholder. Centered, dimmed, dashed border so it
// reads as intentional emptiness rather than a broken render.
export function EmptyStateBlockView({ block }: { block: EmptyStateBlock }) {
  return (
    <div className="rounded-card border border-dashed border-border bg-app-panel2/30 px-4 py-6 text-center text-sm text-app-subtle">
      {block.text}
    </div>
  )
}
